/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Grid } from '@material-ui/core';
import CustomCheckbox from 'components/CustomCheckbox';
import { makeStyles } from '@material-ui/core/styles';
import { ToFromPages } from './ToFromPages';
import Errors from '../../../../Errors';
import { selectLabel } from '../../../services/constants';

const useStyles = makeStyles(() => ({
  label: {
    minWidth: '20rem',
    display: 'inline-block',
  },
}));

export function CombinedFileScope({ type, form, parentClasses, disabled, readOnly, hiddenInputs }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { errors, register, trigger } = form;
  const [state, setState] = useState(false);
  const classes = useStyles();

  const handleChange = async () => {
    await trigger(['gap', 'overlap']);
    setVisible(!visible);
    setState(!state);
  };

  return (
    <Grid key={type} container spacing={1}>
      <Grid item xs={4} md={4} name="combinedFileScopeRow">
        <FormControlLabel
          className={classes.label}
          key={type.uid}
          control={(
            <CustomCheckbox
              inputRef={register()}
              key={type.uid}
              name={type}
              id={type}
              data-testid={type}
              value={state}
              checked={state}
              onChange={handleChange}
              disabled={disabled}
            />
          )}
          label={selectLabel(type, t)}
        />
        <Errors errors={errors} property={type} classes={parentClasses} />
      </Grid>
      <Grid item xs={10} md={10}>
        {visible && !disabled && (
          <ToFromPages type={type} form={form} readOnly={readOnly} hiddenInputs={hiddenInputs} />
        )}
      </Grid>
    </Grid>
  );
}
